import React, { useState, useEffect } from "react";
import Layout from "components/structure/Layout";
import ImportList from "../Common/ImportList";

const ImportWood = () => {
  return (
    <Layout title={"Import Wood Supplier"}>
      <ImportList entityName="ImportWood" displayName="Import Wood Supplier" />
    </Layout>
  );
};

export default ImportWood;
